import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Y si el resultado no me gusta?',
  answer: 'Ingri trabaja contigo para crear el diseño ideal antes de comenzar. Tu mirada, tu decisión.'
}, {
  question: '¿Cuánto duran las extensiones?',
  answer: 'Con el cuidado correcto y la técnica adecuada, de 2 a 3 semanas con retoque mínimo.'
}, {
  question: '¿Dañan la pestaña natural?',
  answer: 'No cuando las aplica una profesional. 8 años de experiencia garantizan técnica segura.'
}, {
  question: '¿Necesito cita o puedo ir de walk-in?',
  answer: 'Se recomienda cita previa. Los turnos se llenan. Escríbele para reservar.'
}, {
  question: '¿Habla español?',
  answer: 'Sí. Ingri atiende completamente en español.'
}, {
  question: '¿Cuánto dura la aplicación de un set nuevo?',
  answer: 'La aplicación de un nuevo set de pestañas toma entre 1 hora 40 minutos y 2 horas, dependiendo del estilo y la cantidad de pestañas.'
}, {
  question: '¿Cuánto dura un refill?',
  answer: 'La duración del refill es de aproximadamente 1 hora y 15 minutos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 bg-white" data-id="element-82">
      <div className="max-w-3xl mx-auto" data-id="element-83">
        <div className="text-center mb-16" data-id="element-84">
          <h2 className="text-3xl md:text-4xl font-serif text-ink mb-4" data-id="element-85">
            Preguntas Frecuentes
          </h2>
          <p className="font-sans text-ink-light" data-id="element-86">
            Todo lo que necesitas saber antes de tu cita.
          </p>
        </div>

        <div className="space-y-4" data-id="element-87">
          {faqs.map((faq, index) => <div key={index} className="border border-gold/20 rounded-sm overflow-hidden" data-id="element-88">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 bg-cream/50 hover:bg-cream transition-colors text-left" data-id="element-89">
                <span className="font-serif text-xl text-ink" data-id="element-90">
                  {faq.question}
                </span>
                <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-91" />
              </button>

              <AnimatePresence data-id="element-92">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-93">
                    <div className="p-6 pt-0 bg-cream/50 font-sans text-ink-light leading-relaxed" data-id="element-94">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}